import { isSupportedCountry } from 'react-phone-number-input';

export function getDefaultCountry(isoCountryCode: string) {
  return isSupportedCountry(isoCountryCode) ? isoCountryCode : 'US';
}
